import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FacultyLinkComponent } from './faculty-link/faculty-link.component';
import { FacultyTrackingNewDashboardComponent } from './faculty-tracking-new-dashboard/faculty-tracking-new-dashboard.component';
import { CampusGoogleMapComponent } from './campus-google-map/campus-google-map.component';

const routes: Routes = [
  {
    path: '', component: FacultyLinkComponent, children:
      [
        { path: 'facultyTrackingDashboard', component: FacultyTrackingNewDashboardComponent },
        { path: 'campusGooglemap', component: CampusGoogleMapComponent }
      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FacultyTrackingDashbaordRoutingModule { }
